import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { Observable } from 'rxjs/Rx';

import { APIURLS, APPSVIEWLABELS, SHAREDCONSTANTS } from '../_constants/constants';
import { environment } from '../../environments/environment';
import { NotificationDialogComponent } from '../notification/notification.dialog.component';
import { App, Link, Links, Scope } from './../_models/data.structures';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { LoaderService } from '../_services/loader.service';



@Injectable()
export class ConsentService {
    private grantedApps: App[];
    private grantedAppLinks: Links;
    private blacklistedApps: App[];
    private blacklistedAppLinks: Links;
    private bannedApps: App[];
    private bannedAppLinks: Links;
    constructor(private router: Router, private http: Http, private translate: TranslateService, private loaderService: LoaderService) {
    }



    RemoveAllAppsTokens(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_All_Apps_Tokens.replace('{sub}', subValue);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    RemoveAllGrantedApps(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_All_Granted_Apps.replace('{sub}', subValue);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    DeleteSingleAppTokens(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Tokens_Delete.replace('{sub}', subValue).replace('{appId}', appId);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }
    RemoveGrantedApp(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remvove_Granted_App.replace('{sub}', subValue).replace('{appId}', appId);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    RemoveBlacklistedApp(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_Blacklisted_App.replace('{sub}', subValue).replace('{appId}', appId);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    RemoveBannedApp(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_Banned_App.replace('{sub}', subValue).replace('{appId}', appId);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }
    RemoveAllBlacklistedApp(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_All_Blacklisted_Apps.replace('{sub}', subValue);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    RemoveAllBannendApp(subValue: string, opcoValue: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Remove_All_Bannend_Apps.replace('{sub}', subValue);
        this.deleteRequest(URL, subValue, opcoValue, ds);
    }

    BanSingleApp(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Ban_App.replace('{sub}', subValue).replace('{appId}', appId);
        this.putRequest(URL, subValue, opcoValue, ds);
    }
    BlacklistSingleApp(subValue: string, opcoValue: string, appId: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_Blacklist_App.replace('{sub}', subValue).replace('{appId}', appId);
        this.putRequest(URL, subValue, opcoValue, ds);
    }



    deleteRequest(url: string, subValue: string, opcoValue: string, ds: DialogService) {
        const header = new Headers();
        header.append('content-type', 'application/json');
        header.append('selected-market', opcoValue);
        header.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: header, withCredentials: true });
        //DetailsComponent.decrementRunningRequests();
        //this.loaderService.display(false);        
        this.http.delete(url, options).subscribe(
            message => {

              //  this.loaderService.display(false);

                setTimeout(() => {
                    this.getGrantedAppsForCustomer(subValue, opcoValue);
                    this.getBlacklistedAppsForCustomer(subValue, opcoValue);
                    this.getBannedAppsForCustomer(subValue, opcoValue);
                }, 1000);

                
                
                setTimeout(() => {
                    this.loaderService.display(false);
                    ds.addDialog(NotificationDialogComponent, {
                        success: true,
                        message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                    });
                    DetailsComponent.decrementRunningRequests();
                }, 3000);
            },
            err => {

                if(this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }

                // if(err.json().code == "IDP_ERROR"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
                DetailsComponent.decrementRunningRequests();
                setTimeout(() => {
                    this.loaderService.display(false);
                }, 3000);
            }
        );
    }

    putRequest(url: string, subValue: string, opcoValue: string, ds: DialogService) {
        const header = new Headers();
        header.append('content-type', 'application/json');
        header.append('selected-market', opcoValue);
        header.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: header, withCredentials: true });
        this.http.put(url, "", options).subscribe(
            message => {

                

                setTimeout(() => {
                    this.getGrantedAppsForCustomer(subValue, opcoValue);
                    this.getBlacklistedAppsForCustomer(subValue, opcoValue);
                    this.getBannedAppsForCustomer(subValue, opcoValue);
                }, 1000);

                
                
                setTimeout(() => {
                    this.loaderService.display(false);

                    ds.addDialog(NotificationDialogComponent, {
                        success: true,
                        message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                    });
                    DetailsComponent.decrementRunningRequests();
                }, 5000);
            },
            err => {

                if(this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }

                // if(err.json().code == "IDP_ERROR"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
                DetailsComponent.decrementRunningRequests();
                setTimeout(() => {
                    this.loaderService.display(false);
                }, 3000);
            }
        );
    }

    singleGrantUpdate(subValue: string, opcoValue: string, appId: string, payload: string, ds: DialogService) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = environment.BASE_URL_BACKEND + APIURLS.APPS_App_Update_Grant.replace('{sub}', subValue).replace('{appId}', appId);
        const header = new Headers();
        header.append('content-type', 'application/json');
        header.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: header, withCredentials: true, body: payload });
        this.http.put(URL,'', options).subscribe(
            message => {
                ds.addDialog(NotificationDialogComponent, {
                    success: true,
                    message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                });
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            },
            err => {

                if(this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }
                
                // if(err.json().code == "IDP_ERROR"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            }
        );
    }

    getGrantedAppsFromLink(URL: string, subValue: string, opcoValue: string) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.grantedApps = res.json().items;
                this.grantedAppLinks = res.json().links;
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }

    getBlacklistedAppsFromLink(URL: string, subValue: string, opcoValue: string) {
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.blacklistedApps = res.json().items;
                this.blacklistedAppLinks = res.json().links;
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }
    getBannedAppsFromLink(URL: string, subValue: string, opcoValue: string) {
        console.log("From Link: " + URL);
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                
                this.bannedApps = res.json().items;
                this.bannedAppLinks = res.json().links;
                this.loaderService.display(false);
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }

    getGrantedAppsForCustomer(subValue: string, opcoValue: string, selectedCountry?: string) {
        this.grantedApps = [];

        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_List).replace('{sub}', subValue);
        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        // if (selectedCountry !== undefined) {                        
        //     headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);            
        // }

        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
               
                this.grantedApps = res.json().items;
                this.grantedAppLinks = res.json().links;

                if (this.grantedApps.length > 0){
                    this.grantedApps.forEach(function(value) { 
                        let item:any = value;
                        if ((item["logo_uri"] !== "") && ((/\.(gif|jpg|jpeg|tiff|png)$/i).test(item["logo_uri"]) === true)) {
                            value["valid_logo_uri"] = true;
                        }
                        else {
                            value["valid_logo_uri"] = false;
                        }                                                                      
                    });
                }    
                this.loaderService.display(false);            
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }

    getBlacklistedAppsForCustomer(subValue: string, opcoValue: string, selectedCountry?: string) {
        this.blacklistedApps = [];

        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Blacklisted_List).replace('{sub}', subValue);
        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        // if (selectedCountry !== undefined) {                        
        //     headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);            
        // }


        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
              
                this.blacklistedApps = res.json().items;
                this.blacklistedAppLinks = res.json().links;

                if (this.blacklistedApps.length > 0) {
                    this.blacklistedApps.forEach(function(value) {
                        let item: any = value;
                        if ((item["logo_uri"] !== "") && ((/\.(gif|jpg|jpeg|tiff|png)$/i).test(item["logo_uri"]) === true)) {
                            value["valid_logo_uri"] = true;
                        }
                        else {
                            value["valid_logo_uri"] = false;
                        }
                    });
                }
                this.loaderService.display(false);
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }

    getBannedAppsForCustomer(subValue: string, opcoValue: string, selectedCountry?: string) {
        this.bannedApps = [];
        
        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Banned_List).replace('{sub}', subValue);
        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        // if (selectedCountry !== undefined) {                        
        //     headers.append('x-vf-trace-nv_opco_id', opcoValue+"-"+selectedCountry);            
        // }
        
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        this.http.get(URL, options).subscribe(
            res => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
                this.bannedApps = res.json().items;
                this.bannedAppLinks = res.json().links;

                if (this.bannedApps.length > 0) {
                    this.bannedApps.forEach(function(value) {
                        let item: any = value;
                        if ((item["logo_uri"] !== "") && ((/\.(gif|jpg|jpeg|tiff|png)$/i).test(item["logo_uri"]) === true)) {
                            value["valid_logo_uri"] = true;
                        }
                        else{
                            value["valid_logo_uri"] = false;
                        }
                    });
                }
            },
            err => {
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            });
    }

    getApp(appid: string, subValue: string, opcoValue: string): Observable<App> {
        const URL = (environment.BASE_URL_BACKEND + APIURLS.APPS_Details).replace('{sub}', subValue).replace('{appId}', appid);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        return this.http.get(URL, options).map(
            data => {
                const app: App = data.json();
                return app;
            }
        );
    }

    findDetail(id:string,opcoValue: string){
       
        const URL = (environment.BASE_URL_BACKEND + APIURLS.DETIAL_DATA).replace('{sub}',id);

        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        return this.http.get(URL, options).map(response => response.json());
    }

    getGrantedApps(): App[] {
        return this.grantedApps;
    }
    getGrantedAppLinks(): Links {
        return this.grantedAppLinks;
    }

    getBlacklistedApps(): App[] {
        return this.blacklistedApps;
    }
    getBlacklistedAppLinks(): Links {
        return this.blacklistedAppLinks;
    }

    getBannedApps(): App[] {
        return this.bannedApps;
    }
    getBannedAppLinks(): Links {
        return this.bannedAppLinks;
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/consent.service.ts